export default __webpack_public_path__ + "static/media/explainer_final.2b313439.png";